import React, { useState, useEffect } from "react";
import { Col, Row, Pagination, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { FormGroup, Spinner } from "react-bootstrap";
import TableData from "./TableData";
import {
  getItemsById,
  getItemsOfCurrentOwnerById,
  sellItemsCurrentOwner,
  getPhysicalArtByUserId,
} from "store/actions";
import { Oval } from "react-loader-spinner";
import PrintComp from "./PrintComp";

// import { tab } from "@testing-library/user-event/dist/tab";

export default function NftCreate(props) {
  const [menu, menuopen] = useOutletContext();
  useEffect(() => {
    menu(false);
  }, [menu]);
  const [printDialog, setprintDialog] = useState(false);
  // Digital Items
  const digitalOwner = useSelector(
    (state) => state?.SellItems?.sellItemsCurrentOwner
  );

  // Physical Items
  const physicalOwner = useSelector(
    (state) => state?.PhysicalSellItems?.physicalArts
  );

  const { loading } = useSelector((state) => state?.SellItems);
  const current_owner = useSelector((state) => state?.Login?.user?._id);
  const dispatch = useDispatch();
  const location = useLocation();
  const pagepath = location.pathname.split("/");
  const [search, setSearch] = useState("");
  const activepath = pagepath.filter((res) => res === "soldbyartist");
  const pagesoldbyartist = activepath[0];
  const navigate = useNavigate();
  const { authToken, user } = useSelector((state) => state?.Login);
  const [numArray, setNumArray] = useState([]);
  const { item } = useSelector((x) => x?.items);
  const displayName =
    item?.nft_id?.name ||
    item?.title_of_artwork ||
    item?.listing_title ||
    "Untitled";

  const displayImage =
    item?.nft_id?.image_id?.image?.link ||
    item?.printable_image_id?.image?.link ||
    item?.printable_image_id?.link ||
    "/images/svg/mpdatanft.svg";

  const Redirect = () => {
    const GetAddress = localStorage.getItem("walletAddress");
    if (GetAddress) {
      navigate("../nft/createnft");
    } else {
      navigate("/metamask-sign");
    }
  };
  
  const [data, setData] = useState([]);

  const [tabs, settabs] = useState("Digital");
  const [timezone, setTimezone] = useState();

  //shahil
  const [digitalNfts, setDigitalNfts] = useState([]);
  const [physicalNfts, setPhysicalNfts] = useState([]);
  const [digitalAvailable, setDigitalAvailable] = useState([]);
  const [digitalSold, setDigitalSold] = useState([]);
  const [physicalAvailable, setPhysicalAvailable] = useState([]);
  const [physicalSold, setPhysicalSold] = useState([]);

  // const [fields, setFields] = useState({
  //   limit: 10000000,
  //   order: -1,
  //   fields: [{
  //     fieldName: "status",
  //     fieldValue: true
  //   },
  //   {
  //     fieldName: "owner_id",
  //     fieldValue: current_owner
  //   }
  //   ]
  // });

  useEffect(() => {
    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezoneString);
  }, []);
  useEffect(() => {
    if (current_owner) {
      const body = { owner_id: current_owner };

      // 1️⃣ Digital artworks (SellItem)
      dispatch(sellItemsCurrentOwner(body));

      // 2️⃣ Physical artworks (PhysicalSellItem)
      dispatch(getPhysicalArtByUserId(current_owner));
    }
  }, [current_owner, dispatch]);

  useEffect(() => {}, [item]);

  useEffect(() => {
    let value = 1;
    value = parseInt(value);

    let x = value * 10 - 10;
    let datas = [];
    for (let i = x; i < value * 10; i++) {
      if (data[i]) {
        datas.push(data[i]);
      }
    }
  }, [data]);

  useEffect(() => {
    const digitalItems = Array.isArray(digitalOwner) ? digitalOwner : [];
    const physicalItems = Array.isArray(physicalOwner) ? physicalOwner : [];

    // Split available / sold
    const digitalAvail = digitalItems.filter(
      (i) => Number(i.available_copies) > 0
    );
    const digitalSold = digitalItems.filter(
      (i) => Number(i.available_copies) === 0
    );
    const physicalAvail = physicalItems.filter(
      (i) => Number(i.available_copies) > 0
    );
    const physicalSold = physicalItems.filter(
      (i) => (Number(i.no_of_copies) === Number(i.physical_sold_count)) && (i.edition != "Open Edition")
    );

    setDigitalNfts(digitalItems);
    setPhysicalNfts(physicalItems);
    setDigitalAvailable(digitalAvail);
    setDigitalSold(digitalSold);
    setPhysicalAvailable(physicalAvail);
    setPhysicalSold(physicalSold);
  }, [digitalOwner, physicalOwner]);

  useEffect(() => {
    let filteredData = [];

    // Select base data based on current tab
    if (tabs === "Digital") {
      filteredData = digitalAvailable;
    } else if (tabs === "DigitalSold") {
      filteredData = digitalSold;
    } else if (tabs === "Physical") {
      // ✅ SHOW ALL PHYSICAL ITEMS (not just available)
      filteredData = physicalNfts; // This contains ALL 3 items
    } else if (tabs === "PhysicalSold") {
      filteredData = physicalSold;
    }

    // Apply search filter
    if (search.trim()) {
      filteredData = filteredData.filter((item) => {
        const name =
          item?.nft_id?.name ||
          item?.title_of_artwork ||
          item?.listing_title ||
          "";
        return name.toLowerCase().includes(search.toLowerCase());
      });
    }

    setData(filteredData);
  }, [
    search,
    tabs,
    digitalAvailable,
    digitalSold,
    physicalNfts, // ✅ Changed from physicalAvailable
    physicalSold,
  ]);

  // <-------------nft print-------------->
  const [selectedNft, setSelectedNft] = useState({});
  const printnftbtn = (item) => {
    setSelectedNft(item);
    setprintDialog(!printDialog);
  };

  /// pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    const totalPages =
      (data?.length || 0) < 9 ? 1 : Math.ceil(data.length / 10);
    const newPages = Array.from({ length: totalPages }, (_, i) => i + 1);
    setDataLength(newPages);
  }, [data, search]);

  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (data[i]) {
        arr.push(data[i]);
      }
    }
    setDataAfterPagination(arr);
    console.log("data", dataAfterPagination);
  }, [values, data, search]);

  useEffect(() => {
    console.log("latestDta", dataAfterPagination);
  }, [dataAfterPagination]);

  const handlePagination = (val) => {
    var valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = parseInt(values) - 10;
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < data.length) {
      // setSNovalue(data.length)
      valu = Math.ceil(data.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };
  
  useEffect(() => {
    setDataLength([1]);
    setValues(10);
  }, [search]);

  const Artisttabs = (name) => {
    settabs(name);
  };

  // useEffect(() => {
  //   console.log("=== DEBUGGING START ===");
  //   console.log("current_owner:", current_owner);
  //   console.log("digitalOwner:", digitalOwner);
  //   console.log("physicalOwner:", physicalOwner);
  //   console.log("=== DEBUGGING END ===");
  // }, [current_owner, digitalOwner, physicalOwner]);



  useEffect(() => {
  console.log("Digital Available:", digitalAvailable);
  console.log("Digital Sold:", digitalSold);
  console.log("Physical Available:", physicalAvailable);
  console.log("Physical Sold:", physicalSold);
  console.log("Current Tab:", tabs);
}, [tabs, digitalAvailable, digitalSold, physicalAvailable, physicalSold]);

  return (
    <>
      {loading && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}

      <Modal
        className="EmailVerifyBoxModel printDialog text-center"
        show={printDialog}
        centered
        animation={false}
      >
        <PrintComp fucn={printnftbtn} nftDet={selectedNft} />
      </Modal>

      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0">
              <i onClick={menuopen} className="fa-light fa-bars-sort"></i>View
              and Create Artworks
            </h1>
            {authToken &&
              (user?.role === "MUSEUM" || user?.role === "ARTIST") &&
              user?.verificationProfileStatus === "accept" && (
                <div className="listmarketbtn">
                  <button className="btn btn-secondary text-white fw-semibold px-5 d-flex align-items-center justify-content-center gap-2">
                    {" "}
                    <i className="fa-light fa-plus"></i> List on Marketplace{" "}
                    <i class="fa-solid fa-caret-down"></i>
                  </button>
                  <div className="dropdownBoxBtn">
                    <ul>
                      <li>
                        <Link to={"../nft/create-digital-nft"}>Digital</Link>
                      </li>
                      <li>
                        <Link to={"../nft/create-physical-nft"}>Physical</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className="TabsBox">
            <Row className="justify-content-between">
              <Col lg={12}>
                <div className="artTab mb-4">
                  <ul>
                    {/* <li
                      onClick={() => Artisttabs("Minted")}
                      className={tabs === "Minted" ? "active" : ""}
                    >
                      Minted
                    </li>
                    <li
                      onClick={() => Artisttabs("Sold")}
                      className={tabs === "Sold" ? "active" : ""}
                    >
                      Sold
                    </li> */}
                    <li
                      onClick={() => Artisttabs("Digital")}
                      className={tabs === "Digital" ? "active" : ""}
                    >
                      Digital
                    </li>
                    <li
                      onClick={() => Artisttabs("DigitalSold")}
                      className={tabs === "DigitalSold" ? "active" : ""}
                    >
                      Digital Sold
                    </li>
                    <li
                      onClick={() => Artisttabs("Physical")}
                      className={tabs === "Physical" ? "active" : ""}
                    >
                      Physical
                    </li>
                    <li
                      onClick={() => Artisttabs("PhysicalSold")}
                      className={tabs === "PhysicalSold" ? "active" : ""}
                    >
                      Physical Sold
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
            {dataAfterPagination.length > 0 || data.length > 0 ? (
              <div className="TabsData mt-4">
                <Row className="justify-content-between">
                  <Col lg={6}>
                    <FormGroup className="position-relative">
                      <Input
                        onChange={(e) => setSearch(e.target.value)}
                        className="form-control searchInput"
                        placeholder="Search"
                      />
                      <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0">
                        <i className="fa-light fa-magnifying-glass"></i>
                      </button>
                    </FormGroup>
                    {/* <p className="pdecription ">Showing 350 {pageName === 'nft' ? 'NFT’s' : 'Collections'}</p> */}
                  </Col>
                  {/* <Col lg={4}>
                                        <div className="d-flex align-item-center gap-3">
                                            <Input type="select" className="form-control searchInput shadow-none">

                                                <option>Low to High</option>
                                                <option>Low to High</option>
                                                <option>Low to High</option>

                                            </Input>
                                            <Input type="select" className="form-control searchInput shadow-none">
                                                <option>WEEKLY</option>
                                                <option>DAILY</option>
                                            </Input>
                                            <button className="btn border-0 clearfilter px-0">
                                                <i className="fa-solid fa-filter-circle-xmark"></i>
                                            </button>
                                        </div>
                                    </Col> */}
                </Row>

                <Row>
                  {tabs === "Digital" && (
                    <Col lg={12}>
                      <div className="table-responsive tableNft">
                        <table>
                          <thead>
                            <tr>
                              <td
                                className="text-left"
                                id="text-left"
                                style={{ width: "4rem !important" }}
                              >
                                No.
                              </td>
                              <td>Artwork Name</td>
                              <td className="text-center">Type</td>
                              <td className="text-center">Sold Artworks</td>
                              {/* <td className="text-center">Total Owners</td> */}

                              <td className="text-center">
                                Available Artworks
                              </td>
                              <td className="text-center">Edition Size</td>
                              <td className="text-center">Sale Type</td>
                              {/* auction/fixed */}
                              <td className="text-center">Date</td>
                              <td className="text-center">Status</td>
                              <td className="text-center">Action</td>
                            </tr>
                          </thead>
                          <tbody>
                            {dataAfterPagination.length > 0 ? (
                              dataAfterPagination?.map((item, index) => (
                                <tr>
                                  <td className="text-left">
                                    {values - 10 + index + 1}
                                  </td>

                                  <td>
                                    <div className="d-flex gap-2 align-items-center">
                                      <img
                                        className="nftimge"
                                        alt=""
                                        src={
                                          item?.nft_id?.image_id?.image?.link ||
                                          item?.nft_id?.image_id?.link ||
                                          item?.printable_image_id?.image
                                            ?.link ||
                                          item?.printable_image_id?.link ||
                                          "/images/svg/mpdatanft.svg"
                                        }
                                      />
                                      <span>
                                        {item?.nft_id?.name ||
                                          item?.title_of_artwork ||
                                          item?.listing_title ||
                                          item?.printable_image_id?.name ||
                                          "Untitled"}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="text-center text-capitalize">
                                    {item?.nft_id?.author_id === item?.owner_id ? "Minted" : "Bought"}
                                  </td>

                                  <td className="text-center">
                                    {Number(item?.no_of_copies) -
                                      Number(item?.available_copies)}
                                  </td>
                                  <td className="text-center">
                                    {item?.available_copies}
                                  </td>
                                  <td className="text-center">
                                    {item?.no_of_copies}
                                  </td>
                                  <td className="text-center text-capitalize">
                                    {item?.sellType}
                                  </td>
                                  {/* <td className="text-center">None</td> */}

                                  {/* <td className="text-center text-capitalize">{item?.created_date}</td> */}
                                  {item?.status === true ||
                                  (item?.available_copies > 0 &&
                                    item.sale_status == "expired") ? (
                                    <td className="text-center text-capitalize">
                                      {new Date(
                                        item?.created_date
                                      ).toLocaleString("en-IN", {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        hour12: true,
                                        timezone: timezone,
                                      })}
                                    </td>
                                  ) : (
                                    <td className="text-center text-capitalize">
                                      {new Date(item?.sold_date).toLocaleString(
                                        "en-IN",
                                        {
                                          month: "short",
                                          day: "numeric",
                                          year: "numeric",
                                          hour: "numeric",
                                          minute: "numeric",
                                          hour12: true,
                                          timezone: timezone,
                                        }
                                      )}
                                    </td>
                                  )}
                                  <td className="text-center">
                                    {pagesoldbyartist === "soldbyartist" ? (
                                      <button className="statusbtt pendingstatus text-capitalize">
                                        Pending
                                      </button>
                                    ) : (
                                      // <button className="statusbtt onsale">On Sale</button>
                                      <button className="statusbtt onsale text-capitalize">
                                        {item?.sale_status}
                                      </button>
                                    )}
                                  </td>
                                  <td className="text-center d-flex align-items-center justify-content-center ">
                                    {/* <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button> */}
                                    <Link
                                      className="btn border-0 "
                                      to={`/profile/nft/viewNft/${item?._id}`}
                                      state={{
                                        NftType: "digital",
                                        type: "bought",
                                      }}
                                    >
                                      <i className="fa-regular fa-eye"></i>
                                    </Link>
                                    {/* <button className="btn border-0 "  onClick={()=>printnftbtn(item)} >   <i className="fa fa-print"></i></button> */}
                                    {/* <button className="btn border-0 no-padding-top"  onClick={()=>printnftbtn(item)} ><img src={"/images/png/proof_reading.png"} className="img-width" alt="" /></button> */}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <>
                                <tr>
                                  <td colSpan={8}>
                                    <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                      <img
                                        src={"/images/svg/mpdatanft.svg"}
                                        className="mb-4"
                                        alt="Create collection"
                                      />
                                      <h3>
                                        {tabs === "Digital" &&
                                          "No Digital Artworks Available"}
                                        {tabs === "DigitalSold" &&
                                          "No Sold Digital Artworks Available"}
                                        {tabs === "Physical" &&
                                          "No Physical Artworks Available"}
                                        {tabs === "PhysicalSold" &&
                                          "No Sold Physical Artworks Available"}
                                      </h3>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  )}
                  {tabs === "DigitalSold" && (
                    <Col lg={12}>
                      <div className="table-responsive tableNft">
                        <table>
                          <thead>
                            <tr>
                              <td
                                className="text-left"
                                id="text-left"
                                style={{ width: "4rem !important" }}
                              >
                                No.
                              </td>
                              <td>Artwork Name</td>
                              <td className="text-center">Sold Artworks</td>
                              {/* <td className="text-center">Total Owners</td> */}
                              <td className="text-center">Edition Size</td>
                              <td className="text-center">Sale Type</td>
                              {/* auction/fixed */}
                              <td className="text-center">Date</td>
                              <td className="text-center">Status</td>
                              <td className="text-center">Action</td>
                            </tr>
                          </thead>
                          <tbody>
                            {dataAfterPagination.length > 0 ? (
                              dataAfterPagination?.map((item, index) => (
                                <tr>
                                  <td className="text-left">
                                    {values - 10 + index + 1}
                                  </td>

                                  <td>
                                    <div className="d-flex gap-2 align-items-center">
                                      <img
                                        className="nftimge"
                                        alt=""
                                        src={
                                          item?.nft_id?.image_id?.image?.link ||
                                          item?.nft_id?.image_id?.link ||
                                          item?.printable_image_id?.image
                                            ?.link ||
                                          item?.printable_image_id?.link ||
                                          "/images/svg/mpdatanft.svg"
                                        }
                                      />
                                      <span>
                                        {item?.nft_id?.name ||
                                          item?.title_of_artwork ||
                                          item?.listing_title ||
                                          item?.printable_image_id?.name ||
                                          "Untitled"}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    {Number(item?.no_of_copies) -
                                      Number(item?.available_copies)}
                                  </td>
                                  <td className="text-center">
                                    {item?.no_of_copies}
                                  </td>
                                  <td className="text-center text-capitalize">
                                    {item?.sellType}
                                  </td>
                                  {/* <td className="text-center">None</td> */}

                                  {/* <td className="text-center text-capitalize">{item?.created_date}</td> */}
                                  {item?.status === true ||
                                  (item?.available_copies > 0 &&
                                    item.sale_status == "expired") ? (
                                    <td className="text-center text-capitalize">
                                      {new Date(
                                        item?.created_date
                                      ).toLocaleString("en-IN", {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        hour12: true,
                                        timezone: timezone,
                                      })}
                                    </td>
                                  ) : (
                                    <td className="text-center text-capitalize">
                                      {new Date(item?.sold_date).toLocaleString(
                                        "en-IN",
                                        {
                                          month: "short",
                                          day: "numeric",
                                          year: "numeric",
                                          hour: "numeric",
                                          minute: "numeric",
                                          hour12: true,
                                          timezone: timezone,
                                        }
                                      )}
                                    </td>
                                  )}
                                  <td className="text-center">
                                    {pagesoldbyartist === "soldbyartist" ? (
                                      <button className="statusbtt pendingstatus text-capitalize">
                                        Pending
                                      </button>
                                    ) : (
                                      // <button className="statusbtt onsale">On Sale</button>
                                      <button className="statusbtt onsale text-capitalize">
                                        {item?.sale_status}
                                      </button>
                                    )}
                                  </td>
                                  <td className="text-center d-flex align-items-center justify-content-center ">
                                    {/* <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button> */}
                                    <Link
                                      className="btn border-0 "
                                      to={`/profile/nft/viewNft/${item?._id}`}
                                      state={{ NftType: "digital" }}
                                    >
                                      <i className="fa-regular fa-eye"></i>
                                    </Link>
                                    {/* <button className="btn border-0 "  onClick={()=>printnftbtn(item)} >   <i className="fa fa-print"></i></button> */}
                                    {/* <button className="btn border-0 no-padding-top"  onClick={()=>printnftbtn(item)} ><img src={"/images/png/proof_reading.png"} className="img-width" alt="" /></button> */}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <>
                                <tr>
                                  <td colSpan={8}>
                                    <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                      <img
                                        src={"/images/svg/mpdatanft.svg"}
                                        className="mb-4"
                                        alt="Create collection"
                                      />
                                      <h3>
                                        {tabs === "Digital" &&
                                          "No Digital Artworks Available"}
                                        {tabs === "DigitalSold" &&
                                          "No Sold Digital Artworks Available"}
                                        {tabs === "Physical" &&
                                          "No Physical Artworks Available"}
                                        {tabs === "PhysicalSold" &&
                                          "No Sold Physical Artworks Available"}
                                      </h3>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  )}

                  {tabs === "Physical" && (
                    <Col lg={12}>
                      <div className="table-responsive tableNft">
                        <table>
                          <thead>
                            <tr>
                              <td
                                className="text-left"
                                id="text-left"
                                style={{ width: "4rem !important" }}
                              >
                                No.
                              </td>
                              <td>Artwork Name</td>
                              <td className="text-center">Sold Artworks</td>
                              <td className="text-center">
                                Available Artworks
                              </td>
                              <td className="text-center">Edition Size</td>
                              <td className="text-center">Edition Type</td>
                              <td className="text-center">Date</td>
                              <td className="text-center">Status</td>
                              <td className="text-center">Action</td>
                            </tr>
                          </thead>
                          <tbody>
                            {dataAfterPagination.length > 0 ? (
                              dataAfterPagination?.map((item, index) => {
                                const physicalImage =
                                  item?.listing_image_id
                                    ?.water_mark_image_link || // Watermarked listing image
                                  item?.listing_image_id?.link || // Original listing image
                                  "/images/svg/mpdatanft.svg";

                                const physicalName =
                                  item?.title_of_artwork ||
                                  item?.listing_title ||
                                  item?.item_info?.name?.replace(
                                    /\.\w+$/,
                                    ""
                                  ) ||
                                  "Untitled";

                                return (
                                  <tr key={item._id}>
                                    <td className="text-left">
                                      {values - 10 + index + 1}
                                    </td>

                                    <td>
                                      <div className="d-flex gap-2 align-items-center">
                                        <img
                                          className="nftimge"
                                          alt={physicalName}
                                          src={physicalImage}
                                        />
                                          <span>
                                            {physicalName?.length > 30
                                              ? physicalName.slice(0, 30) + "..."
                                              : physicalName}
                                          </span>
                                      </div>
                                    </td>

                                    <td className="text-center">
                                      {item?.physical_sold_count || 0}
                                      
                                    </td>

                                    <td className="text-center">
                                      {item?.edition?.toLowerCase() != "limited edition"
                                        ? "—"
                                        : Number(item?.available_copies || 0)}
                                    </td>

                                    <td className="text-center">
                                      {item?.edition?.toLowerCase() != "limited edition"
                                        ? "—"
                                        : item?.no_of_copies || 0}
                                    </td>

                                    <td className="text-center text-capitalize">
                                      {item?.edition || "—"}
                                    </td>

                                    <td className="text-center text-capitalize">
                                      {item?.created_date ? (
                                        new Date(
                                          typeof item.created_date === "number"
                                            ? item.created_date * 1000 // convert seconds → milliseconds
                                            : item.created_date         // keep ISO string as-is
                                        ).toLocaleString("en-IN", {
                                          month: "short",
                                          day: "numeric",
                                          year: "numeric",
                                          hour: "numeric",
                                          minute: "numeric",
                                          hour12: true,
                                          timeZone: timezone,
                                        })
                                      ) : (
                                        "—"
                                      )}
                                    </td>
                                    <td className="text-center">
                                      <button className="statusbtt onsale text-capitalize">
                                        {item?.sale_status || "onsale"}
                                      </button>
                                    </td>

                                    <td className="text-center d-flex align-items-center justify-content-center">
                                      <Link
                                        className="btn border-0"
                                        to={`/profile/nft/viewNft/${item?._id}`}
                                        state={{ NftType: "physical" }}
                                      >
                                        <i className="fa-regular fa-eye"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={9}>
                                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                    <img
                                      src={"/images/svg/mpdatanft.svg"}
                                      className="mb-4"
                                      alt="No artworks"
                                    />
                                    <h3>No Physical Artworks Available</h3>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  )}

                  {tabs === "PhysicalSold" && (
                    <Col lg={12}>
                      <div className="table-responsive tableNft">
                        <table>
                          <thead>
                            <tr>
                              <td
                                className="text-left"
                                id="text-left"
                                style={{ width: "4rem !important" }}
                              >
                                No.
                              </td>
                              <td>Artwork Name</td>
                              <td className="text-center">Sold Artworks</td>
                              <td className="text-center">Edition Size</td>
                              <td className="text-center">Edition Type</td>
                              <td className="text-center">Date</td>
                              <td className="text-center">Status</td>
                              <td className="text-center">Action</td>
                            </tr>
                          </thead>
                          <tbody>
                            {dataAfterPagination.length > 0 ? (
                              dataAfterPagination?.map((item, index) => {
                                //  Get the correct image for physical artwork
                                const physicalImage =
                                  item?.listing_image_id?.water_mark_image_link ||
                                  item?.printable_image_id?.link ||
                                  "/images/svg/mpdatanft.svg";

                                // Get the correct name for physical artwork
                                const physicalName =
                                  item?.title_of_artwork ||
                                  item?.listing_title ||
                                  item?.item_info?.name?.replace(
                                    /\.\w+$/,
                                    ""
                                  ) ||
                                  "Untitled";

                                return (
                                  <tr key={item._id}>
                                    <td className="text-left">
                                      {values - 10 + index + 1}
                                    </td>

                                    <td>
                                      <div className="d-flex gap-2 align-items-center">
                                        <img
                                          className="nftimge"
                                          alt={physicalName}
                                          src={physicalImage}
                                        />
                                        <span>{physicalName}</span>
                                      </div>
                                    </td>

                                    <td className="text-center">
                                      
                                      {Number(item?.physical_sold_count || 0) }
                                    </td>

                                    <td className="text-center">
                                     {item?.edition?.toLowerCase() != "limited edition"
                                        ? "—" :  Number(item?.no_of_copies || 0) }
                                    </td>

                                    <td className="text-center text-capitalize">
                                      {item?.edition || "—"}
                                    </td>

                                    <td className="text-center text-capitalize">
                                      {item?.sold_date
                                        ? new Date(
                                            item.sold_date
                                          ).toLocaleString("en-IN", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                            hour12: true,
                                            timeZone: timezone,
                                          })
                                        : item?.created_date
                                        ? new Date(
                                            item.created_date
                                          ).toLocaleString("en-IN", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                            hour12: true,
                                            timeZone: timezone,
                                          })
                                        : "—"}
                                    </td>

                                    <td className="text-center">
                                      <button className="statusbtt onsale text-capitalize">
                                        {item?.sale_status || "sold"}
                                      </button>
                                    </td>

                                    <td className="text-center d-flex align-items-center justify-content-center">
                                      <Link
                                        className="btn border-0"
                                        to={`/profile/nft/viewNft/${item?._id}`}
                                        state={{ NftType: "physical" }}
                                      >
                                        <i className="fa-regular fa-eye"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={8}>
                                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                    <img
                                      src={"/images/svg/mpdatanft.svg"}
                                      className="mb-4"
                                      alt="No sold physical artworks"
                                    />
                                    <h3>No Sold Physical Artworks Available</h3>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  )}

                  <Col lg={12} className="d-none">
                    <div className="table-responsive tableNft">
                      <table>
                        <thead>
                          <tr>
                            <td
                              className="text-left"
                              id="text-left"
                              style={{ width: "4rem !important" }}
                            >
                              No.
                            </td>
                            <td>Artwork Name</td>
                            <td className="text-center">Sold Artworks</td>
                            {/* <td className="text-center">Total Owners</td> */}
                            <td className="text-center">Available Artworks</td>
                            <td className="text-center">Edition Size</td>
                            <td className="text-center">Sale Type</td>
                            {/* auction/fixed */}
                            <td className="text-center">Date</td>
                            <td className="text-center">Status</td>
                            <td className="text-center">Action</td>
                          </tr>
                        </thead>
                        <tbody>
                          {dataAfterPagination.length > 0 ? (
                            dataAfterPagination?.map((item, index) => (
                              <tr>
                                <td className="text-left">
                                  {values - 10 + index + 1}
                                </td>

                                <td>
                                  <div className="d-flex gap-2 align-items-center">
                                    <img
                                      className="nftimge"
                                      alt=""
                                      src={
                                        item?.printable_image_id?.image?.link ||
                                        item?.printable_image_id?.link ||
                                        "/images/svg/mpdatanft.svg"
                                      }
                                    />
                                    <span>
                                      {item?.title_of_artwork ||
                                        item?.listing_title ||
                                        item?.printable_image_id?.name ||
                                        "Untitled"}
                                    </span>
                                  </div>
                                </td>
                                <td className="text-center">
                                  {Number(item?.no_of_copies) -
                                    Number(item?.available_copies)}
                                </td>
                                <td className="text-center">
                                  {item?.available_copies}
                                </td>
                                <td className="text-center">
                                  {item?.no_of_copies}
                                </td>
                                <td className="text-center text-capitalize">
                                  {item?.sellType}
                                </td>
                                {/* <td className="text-center">None</td> */}

                                {/* <td className="text-center text-capitalize">{item?.created_date}</td> */}
                                {item?.status === true ||
                                (item?.available_copies > 0 &&
                                  item.sale_status == "expired") ? (
                                  <td className="text-center text-capitalize">
                                    {new Date(
                                      item?.created_date
                                    ).toLocaleString("en-IN", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                      hour: "numeric",
                                      minute: "numeric",
                                      hour12: true,
                                      timezone: timezone,
                                    })}
                                  </td>
                                ) : (
                                  <td className="text-center text-capitalize">
                                    {new Date(item?.sold_date).toLocaleString(
                                      "en-IN",
                                      {
                                        month: "short",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                        hour12: true,
                                        timezone: timezone,
                                      }
                                    )}
                                  </td>
                                )}
                                <td className="text-center">
                                  {pagesoldbyartist === "soldbyartist" ? (
                                    <button className="statusbtt pendingstatus text-capitalize">
                                      Pending
                                    </button>
                                  ) : (
                                    // <button className="statusbtt onsale">On Sale</button>
                                    <button className="statusbtt onsale text-capitalize">
                                      {item?.sale_status}
                                    </button>
                                  )}
                                </td>
                                <td className="text-center d-flex align-items-center justify-content-center ">
                                  {/* <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button> */}
                                  <Link
                                    className="btn border-0 "
                                    to={`/profile/nft/viewNft/${item?._id}`}
                                  >
                                    <i className="fa-regular fa-eye"></i>
                                  </Link>
                                  <button
                                    className="btn border-0 "
                                    onClick={() => printnftbtn(item)}
                                  >
                                    {" "}
                                    <i className="fa fa-print"></i>
                                  </button>
                                  {/* <button className="btn border-0 no-padding-top"  onClick={()=>printnftbtn(item)} ><img src={"/images/png/proof_reading.png"} className="img-width" alt="" /></button> */}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <>
                              <tr>
                                <td colSpan={8}>
                                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                    <img
                                      src={"/images/svg/mpdatanft.svg"}
                                      className="mb-4"
                                      alt="Create collection"
                                    />
                                    <h3>
                                      {tabs === "Digital" &&
                                        "No Digital Artworks Available"}
                                      {tabs === "DigitalSold" &&
                                        "No Sold Digital Artworks Available"}
                                      {tabs === "Physical" &&
                                        "No Physical Artworks Available"}
                                      {tabs === "PhysicalSold" &&
                                        "No Sold Physical Artworks Available"}
                                    </h3>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                          {/* {currentOwner && currentOwner.map((item, index)=>{
                        <tr> */}
                          {/* <td className="text-center">1</td>
                          <td><img className="nftimge" alt="" src={"../../images/png/artist4.png"} /> {item.name}</td>
                          <td className="text-center">1</td>
                          <td className="text-center">10</td>
                          <td className="text-center">1</td>
                          <td className="text-center">None</td>
                          <td className="text-center">
                            {pagesoldbyartist === 'soldbyartist' ? (<button className="statusbtt verifiesstatus">Verified</button>) : (
                              <button className="statusbtt onsale">On Sale</button>
                            )}
                          </td>
                          <td className="text-center">
                            <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                          </td>
                        </tr>})} */}
                          {/* <tr>
                          <td className="text-center">1</td>
                          <td><img className="nftimge" alt="" src={"../../images/png/artist4.png"} /> Artwork Name</td>
                          <td className="text-center">1</td>
                          <td className="text-center">10</td>
                          <td className="text-center">1</td>
                          <td className="text-center">None</td>
                          <td className="text-center">
                            {(pagesoldbyartist === 'soldbyartist') ? (<button className="statusbtt rejectedstatus">Rejected</button>) : (
                              <button className="statusbtt onsale">On Sale</button>
                            )}
                          </td>
                          <td className="text-center">
                            <button className="btn border-0"><i className="fa-regular fa-pen-to-square"></i></button>
                            <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                          </td>
                        </tr> */}
                        </tbody>
                        {/* {
                          // numArray && numArray?.map((item, index) => { return <h1 id="1" onClick={() => handleTableClick(item)}>{item}</h1> })
                         <> { currentVal > firstVal && <h1 id="1" onClick={() => handleTableClick("<")}>{"<"}</h1>  } <h1 id="1" onClick={() => handleTableClick(firstVal)}>{firstVal}</h1> ............ <h1 id="1" onClick={() => handleTableClick(lastVal)}>{lastVal}</h1>  { currentVal < lastVal && <h1 id="1" onClick={() => handleTableClick(">")}>{">"}</h1>} </>
                        } */}
                      </table>
                    </div>
                  </Col>
                  {dataAfterPagination.length > 0 && (
                    <Col lg={12} className="text-end">
                      <Pagination
                        className="paginationNew"
                        aria-label="Page  navigation example"
                      >
                        {values > 10 && (
                          <div className="d-flex align-items-center gap-2">
                            <PaginationItem>
                              <PaginationLink
                                first
                                href="#"
                                onClick={() => handlePagination("<<")}
                              />
                            </PaginationItem>
                            <PaginationItem>
                              <PaginationLink
                                href="#"
                                previous
                                onClick={() => handlePagination("<")}
                              />
                            </PaginationItem>
                          </div>
                        )}
                        {dataLength &&
                          dataLength.map((item) => (
                            <PaginationItem
                              className={
                                parseInt(item) === values / 10 ? "active" : ""
                              }
                            >
                              <PaginationLink
                                href="#"
                                onClick={() => handlePagination(item)}
                              >
                                {item}
                              </PaginationLink>
                            </PaginationItem>
                          ))}

                        {values < data.length && (
                          <div className="d-flex align-items-center gap-2">
                            <PaginationItem>
                              <PaginationLink
                                href="#"
                                next
                                onClick={() => handlePagination(">")}
                              />
                            </PaginationItem>
                            <PaginationItem>
                              <PaginationLink
                                href="#"
                                last
                                onClick={() => handlePagination(">>")}
                              />
                            </PaginationItem>
                          </div>
                        )}
                      </Pagination>
                    </Col>
                  )}
                </Row>
              </div>
            ) : (
              <div className="text-center d-grid justify-content-center dataNotFound py-5">
                <img
                  src={"../../images/svg/mpdatanft.svg"}
                  alt="Create collection"
                />
                <h3>
                  {tabs === "Digital" && "No Digital Artworks Available"}
                  {tabs === "DigitalSold" &&
                    "No Sold Digital Artworks Available"}
                  {tabs === "Physical" && "No Physical Artworks Available"}
                  {tabs === "PhysicalSold" &&
                    "No Sold Physical Artworks Available"}
                </h3>
                {/* {authToken &&
                    (user?.role === "MUSEUM" || user?.role === "ARTIST") &&
                    user?.verificationProfileStatus === "accept" && (
                      <button 
                      ={Redirect} className="btn btn-primary px-5"> <i className="fa-light fa-plus"></i> List on Marketplace</button>
                    )} */}
              </div>
            )}
          </div>
        </Col>
      </Row>
      {loading ? (
        <Spinner animation="border" size="sm" role="status"></Spinner>
      ) : (
        ""
      )}
    </>
  );
}
